module.exports = __webpack_public_path__ + "static/img/template_img_04.a1499ff3.jpg";